import { default as activity } from './activity/routes'
import { default as category } from './category/routes'

export default [
    ...activity,
    ...category,
]